import { Hourglass } from "lucide-react";

interface ComingSoonProps {
  title: string;
}

const ComingSoon = ({ title }: ComingSoonProps) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <h1 className="text-3xl font-bold text-foreground mb-8">{title}</h1>
      <div className="p-6 rounded-full bg-muted/30 mb-6">
        <Hourglass className="h-10 w-10 text-muted-foreground/50" />
      </div>
      <p className="text-lg text-muted-foreground">Coming soon</p>
    </div>
  );
};

export default ComingSoon;
